import React from 'react'

const SettingsMenuSkeleton = () => (
  <div
    className={`bg-background-secondary inset-0 flex h-fit w-full animate-pulse flex-col overflow-auto rounded-md last:border-b-transparent lg:w-[250px]`}
  >
    <div className="border-b-text-secondary/10 border-b px-5 py-2.5">
      <div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-5 py-2.5">
      <div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-5 py-2.5">
      <div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-5 py-2.5">
      <div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div>
    </div>
    <div className="border-b-text-secondary/10 border-b px-5 py-2.5">
      <div className="bg-skeleton-primary my-0.5 rounded-sm text-transparent">.</div>
    </div>
  </div>
)

export default SettingsMenuSkeleton
